export const verifyModuleEnabled = (company, accessConfig) =>
  accessConfig?.alwaysEnabled || (company.modules && company.modules[accessConfig?.moduleName])
